export const REQUIRED_ACTION_PULSE_ANIMATION_NAME = 'required-action-pulse';
export const REQUIRED_ACTION_PULSE_DURATION_MS = 500;
